"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionHandlerErrors = exports.mwPermissions = exports.loginTypes = exports.default = exports.appTypes = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _sha = _interopRequireDefault(require("crypto-js/sha256"));
var _encBase = _interopRequireDefault(require("crypto-js/enc-base64"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _Unauthenticated = _interopRequireDefault(require("../cic/errors/Unauthenticated"));
var _CacheHandler = _interopRequireDefault(require("./CacheHandler"));
var _ActivityWatcher = _interopRequireDefault(require("./ActivityWatcher"));
var _config = _interopRequireDefault(require("../cic/config/config"));
var _globalStrings = require("./globalStrings");
// import moment from 'moment';

_momentTimezone.default.tz.setDefault('Europe/Berlin');
// const loginTypes = {
//   loggedIn: 'loggedin',
//   anonym: 'anonym',
//   callCenter: 'callcenter',
//   incompleteLoggedIn: 'incompleteLoggedIn',
// };
var storageKeys = /*#__PURE__*/function (storageKeys) {
  storageKeys["intermediateReadingMeterNumber"] = "intermediateReadingMeterNumber";
  return storageKeys;
}(storageKeys || {});
var loginTypes = exports.loginTypes = /*#__PURE__*/function (loginTypes) {
  loginTypes["loggedIn"] = "loggedin";
  loginTypes["anonym"] = "anonym";
  loginTypes["postal"] = "postal";
  loginTypes["callCenter"] = "callcenter";
  loginTypes["incompleteLoggedIn"] = "incompleteLoggedIn";
  return loginTypes;
}(loginTypes || {});
var appTypes = exports.appTypes = /*#__PURE__*/function (appTypes) {
  appTypes["cic"] = "001";
  appTypes["ekuss"] = "002";
  appTypes["ekuss2"] = "003";
  appTypes["cscn"] = "004";
  return appTypes;
}(appTypes || {});
var storedContracts;
var permissions = null;
var mwPermissions = exports.mwPermissions = {
  ablRead: 'ABL_READ',
  // read meter reading orders
  adrRead: 'ADR_READ',
  // check or complete address from regional structure
  anlRead: 'ANL_READ',
  // read installation details
  bankInsert: 'BANK_INSERT',
  // insert bank details/collection authorization
  bankRead: 'BANK_READ',
  // read bank details/collection authorization
  bankUpdate: 'BANK_UPDATE',
  // change bank details/collection authorization
  bbpRead: 'BBP_READ',
  // read budget billing plan
  bbpUpdate: 'BBP_UPDATE',
  // change budget billing plan
  ctcWrite: 'CTC_WRITE',
  // send contact form
  detailProRead: 'DETAIL_PRO_READ',
  // read product details
  detailVtrRead: 'DETAIL_VTR_READ',
  // read contract details
  digimondoRead: 'DIGIMONDO_READ',
  // read digimondo optIn
  digimondoUpdate: 'DIGIMONDO_UPDATE',
  // change digimondo optIn
  digiwerteRead: 'DIGIWERTE_READ',
  // read digimondo meter data
  dvsatzDelete: 'DVSATZ_DELETE',
  // delete direct marketing compensation rate
  dvsatzInsert: 'DVSATZ_INSERT',
  // add direct marketing compensation rate
  dvsatzRead: 'DVSATZ_READ',
  // read direct marketing compensation rates
  einmawetterUpload: 'EIMAWETTER_UPLOAD',
  // upload EinsMan weather data
  einsmanRead: 'EINSMAN_READ',
  // read EinsMan reimbursement method
  einsmanUpdate: 'EINSMAN_UPDATE',
  // change EinsMan reimbursement method
  faqRead: 'FAQ_READ',
  // show f.a.q.
  gerRead: 'GER_READ',
  // read contract details and/or technical details
  komDelete: 'KOM_DELETE',
  // delete communication data
  komInsert: 'KOM_INSERT',
  // add communication data
  komRead: 'KOM_READ',
  // read communication data
  komUpdate: 'KOM_UPDATE',
  // change communication data
  ksaOnlRead: 'KSA_ONL_READ',
  // read KSA status
  ksaOnlUpdate: 'KSA_ONL_UPDATE',
  // change KSA status
  korrOnlRead: 'KORR_ONL_READ',
  // read correspondance status
  korrOnlUpdate: 'KORR_ONL_UPDATE',
  // read correspondance status
  ldapInsert: 'LDAP_INSERT',
  // complete registration
  ldapRead: 'LDAP_READ',
  // read user account data
  ldapUpdate: 'LDAP_UPDATE',
  // change user account data
  lgangaboDelete: 'LGANGABO_DELETE',
  // cancel load profile subscription
  lgangaboInsert: 'LGANGABO_INSERT',
  // add load profile subscription
  lgangaboRead: 'LGANGABO_READ',
  // read load profile subscriptions
  lgangaboUpdate: 'LGANGABO_UPDATE',
  // change load profile subscriptions
  mtrInsert: 'MTR_INSERT',
  // add meter readings
  mtrRead: 'MTR_READ',
  // read meter readings
  orderRead: 'ORDER_READ',
  // read open orders (track&trace)
  pboxRead: 'PBOX_READ',
  // read post box
  recRead: 'REC_READ',
  // read bills
  regulationRead: 'REGULATION_READ',
  // read regulations
  rlmLastgRead: 'RLM_LASTG_READ',
  // read load profile
  slpLastgCompare: 'SLP_LASTG_COMPARE',
  // compare measured values
  slpLastgRead: 'SLP_LASTG_READ',
  // read measured values
  taxnumRead: 'TAXNUM_READ',
  // read tax numbers
  taxnumUpdate: 'TAXNUM_UPDATE',
  // change tax numbers
  vertreterWrite: 'VERTRETER_WRITE',
  // authorize proxy
  vhisRead: 'VHIS_READ',
  // read consumption history
  vkAdd: 'VK_ADD',
  // add contract account to user account
  vtrRead: 'VTR_READ',
  // read contract data or meter reading orders
  zdatRead: 'ZDAT_READ',
  // read due dates from budget billing plan
  hanInsert: 'HAN_INSERT',
  // read han username and password
  apptMtr: 'ASS_ORDER_CHANGE' // manage meter exchange appointment
};
var storage;
var sessionHandlerErrors = exports.sessionHandlerErrors = {
  loginTypeError: 'Proper login type is not specified!',
  startSessionCalledBefore: 'startSession has to be called before init session',
  notLoggedIn: 'Not logged in'
};
var SessionHandler = /*#__PURE__*/function () {
  function SessionHandler() {
    (0, _classCallCheck2.default)(this, SessionHandler);
    (0, _defineProperty2.default)(this, "permissionsSet", void 0);
  }
  (0, _createClass2.default)(SessionHandler, [{
    key: "setStorage",
    value: function setStorage(newStorage) {
      storage = newStorage;
    }
  }, {
    key: "startSession",
    value: function startSession() {
      if (!storage) {
        storage = window.sessionStorage;
      }
      storage.sessStarted = true;
    }
  }, {
    key: "initSession",
    value: function initSession(userName, token) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : loginTypes.loggedIn;
      if (!storage.sessStarted) {
        throw new Error(sessionHandlerErrors.startSessionCalledBefore);
      }
      if (!Object.values(loginTypes).includes(type)) {
        throw new Error(sessionHandlerErrors.loginTypeError);
      }
      storage.userNamev2 = userName;
      if (typeof token === 'string') {
        this.setToken(token, _globalStrings.TOKEN_NAME_CSC);
      } else {
        this.setToken(token.accessToken, _globalStrings.TOKEN_NAME_CIAM);
        this.setRefreshToken(token.refreshToken);
      }
      storage.loginType2 = type;
    }
  }, {
    key: "getLoginType",
    value: function getLoginType() {
      return storage.loginType2;
    }
  }, {
    key: "setLoginType",
    value: function setLoginType(type) {
      storage.loginType2 = type;
    }
  }, {
    key: "getRedirectUrl",
    value: function getRedirectUrl(type) {
      var anonymUrl = _config.default.AEM_CONFIG.expiredSessionURL;
      var ssoUrl = _config.default.AEM_CONFIG.SSO.ssoSessionExpiredUrl;
      var isAnonym = typeof type === 'string' || !type ? type === loginTypes.anonym : type.includes(loginTypes.anonym);
      return isAnonym ? anonymUrl : ssoUrl;
    }
  }, {
    key: "destroyRemoteSso",
    value: function destroyRemoteSso() {
      location.replace(_config.default.AEM_CONFIG.SSO.ssoLogout);
    }
  }, {
    key: "generateSSOLoginUrl",
    value: function generateSSOLoginUrl() {
      this.setCurrentCodeVerifier(this.generateCodeVerifier());
      var codeVerifier = this.getCurrentCodeVerifier();
      var codeChallange = "&code_challenge=".concat(this.generateCodeChallenge(codeVerifier), "&code_challenge_method=S256");
      return "".concat(_config.default.AEM_CONFIG.SSO.ssoLoginUrl, "&client_id=").concat(encodeURIComponent(_config.default.AEM_CONFIG.SSO.clientId), "&redirect_uri=").concat(encodeURIComponent(_config.default.AEM_CONFIG.SSO.loginBridgePath)).concat(codeChallange, "}");
    }
  }, {
    key: "setCurrentCodeVerifier",
    value: function setCurrentCodeVerifier(code) {
      sessionStorage.setItem('code_verifier', code);
    }
  }, {
    key: "getCurrentCodeVerifier",
    value: function getCurrentCodeVerifier() {
      return sessionStorage.getItem('code_verifier');
    }
  }, {
    key: "removeCodeVerifier",
    value: function removeCodeVerifier() {
      sessionStorage.removeItem('code_verifier');
    }
  }, {
    key: "parseJwt",
    value: function parseJwt(token) {
      if (!token) {
        return null;
      }
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return "%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2));
      }).join(''));
      return JSON.parse(jsonPayload);
    }
  }, {
    key: "destroyLocalSession",
    value: function destroyLocalSession() {
      _CacheHandler.default.clearAllCache(true);
      delete storage.ids;
      delete storage.token;
      delete storage.tokenv2;
      delete storage.userName;
      delete storage.userNamev2;
      delete storage.loginType;
      delete storage.refreshToken;
      delete storage.ciamtoken;
      delete storage.counterId;
      delete storage.loginType2;
      delete storage.csctoken;
      delete storage.intermediateReadingMeterNumber;
      _ActivityWatcher.default.cleanupLocalData();
    }
  }, {
    key: "setLogoutSuccessPage",
    value: function setLogoutSuccessPage(logoutType) {
      storage.logoutPage = logoutType;
    }
  }, {
    key: "getLogoutSuccessPage",
    value: function getLogoutSuccessPage() {
      return storage.logoutPage;
    }
  }, {
    key: "destroySession",
    value: function destroySession() {
      var redirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var customReidrectUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var additionalParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      if (redirect) {
        sessionStorage.cscRedirectLock = 1;
      }
      if (SessionHandler.localRedirectLock) {
        return;
      }
      if ([loginTypes.loggedIn, loginTypes.callCenter, loginTypes.incompleteLoggedIn].includes(this.getLoginType())) {
        if (redirect) {
          SessionHandler.localRedirectLock = true;
          this.setLogoutSuccessPage("".concat(customReidrectUrl || this.getRedirectUrl(this.getLoginType())).concat(additionalParams));
          this.destroyLocalSession();
          this.destroyRemoteSso();
        } else {
          this.destroyLocalSession();
        }
        if (callback) {
          callback();
        }
      } else {
        this.destroyLocalSession();
        if (callback) {
          callback();
        }
        if (redirect) {
          if (customReidrectUrl) {
            location.replace(customReidrectUrl);
          } else {
            location.replace(this.getRedirectUrl(this.getLoginType()));
          }
        }
      }
    }
  }, {
    key: "getPermissions",
    value: function getPermissions() {
      return permissions;
    }
  }, {
    key: "setPermissions",
    value: function setPermissions(contracts, contractId) {
      var _selectedContract$per;
      storedContracts = contracts;
      if (!contracts[0]) {
        this.resetPermissions();
        return;
      }
      var selectedContract = contracts.find(function (contract) {
        return contract.contractAccountId === contractId;
      });
      permissions = (selectedContract === null || selectedContract === void 0 ? void 0 : (_selectedContract$per = selectedContract.permissions) === null || _selectedContract$per === void 0 ? void 0 : _selectedContract$per.length) ? selectedContract.permissions : null;
      this.permissionsSet = true;
    }
  }, {
    key: "resetPermissions",
    value: function resetPermissions() {
      permissions = null;
    }
  }, {
    key: "checkForPermissions",
    value: function checkForPermissions() {
      if (this.isUserLoggedIn([loginTypes.loggedIn, loginTypes.anonym, loginTypes.callCenter]) && !permissions) {
        var _contracts$data;
        var contracts = _CacheHandler.default.getCurrentCacheByToken('contractaccounts');
        if (contracts === null || contracts === void 0 ? void 0 : (_contracts$data = contracts.data) === null || _contracts$data === void 0 ? void 0 : _contracts$data.content.length) {
          this.setPermissions(contracts.data.content, contracts.data.content[0].contractAccountId);
        }
      }
    }
  }, {
    key: "hasPermissionsByMwToken",
    value: function hasPermissionsByMwToken(requiredPermissions) {
      var _this = this;
      var allContracts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var stringChunk = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var jsKeys = Object.keys(mwPermissions);
      var searchMethod = stringChunk ? function (key) {
        return !!requiredPermissions.find(function (rElem) {
          return mwPermissions[key].indexOf(rElem) !== -1;
        });
      } : function (key) {
        return requiredPermissions.includes(mwPermissions[key]);
      };
      var filteredPerms = jsKeys.filter(searchMethod);
      if (!filteredPerms.length) {
        return false;
      }
      return stringChunk ? !!filteredPerms.find(function (fPerm) {
        return _this.hasPermissions([fPerm], allContracts);
      }) : this.hasPermissions(filteredPerms, allContracts);
    }
  }, {
    key: "hasPermissions",
    value: function hasPermissions(requiredPermissions) {
      var allContracts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var hasAllPermissions = true;
      var hasPermission;
      this.checkForPermissions();
      if (!permissions || !(requiredPermissions === null || requiredPermissions === void 0 ? void 0 : requiredPermissions.length)) {
        return false;
      }
      requiredPermissions.forEach(function (permission) {
        if (allContracts) {
          storedContracts.forEach(function (contract) {
            hasPermission = contract.permissions.includes(mwPermissions[permission]) || hasPermission;
          });
        } else {
          hasPermission = !!permissions.find(function (x) {
            return x.startsWith(permission);
          }) || permissions.includes(mwPermissions[permission]);
        }
        hasAllPermissions = hasAllPermissions && hasPermission;
      });
      return hasAllPermissions;
    }
  }, {
    key: "userMustBeLoggedIn",
    value: function userMustBeLoggedIn(types) {
      var _CONFIG$AEM_CONFIG;
      if (_config.default === null || _config.default === void 0 ? void 0 : (_CONFIG$AEM_CONFIG = _config.default.AEM_CONFIG) === null || _CONFIG$AEM_CONFIG === void 0 ? void 0 : _CONFIG$AEM_CONFIG.isA11yModeEnabled) {
        return;
      }
      types.forEach(function (type) {
        if (!Object.values(loginTypes).includes(type)) {
          throw new Error(sessionHandlerErrors.loginTypeError);
        }
      });
      if (!this.isUserLoggedIn(types)) {
        var newExp = new _Unauthenticated.default(sessionHandlerErrors.notLoggedIn);
        newExp.loginType = types;
        throw newExp;
      }
    }
  }, {
    key: "isUserLoggedIn",
    value: function isUserLoggedIn(types) {
      types.forEach(function (type) {
        if (!Object.values(loginTypes).includes(type)) {
          throw new Error(sessionHandlerErrors.loginTypeError);
        }
      });
      return !!storage && !!this.getName() && types.includes(this.getLoginType());
    }
  }, {
    key: "getName",
    value: function getName() {
      var _storage;
      return ((_storage = storage) === null || _storage === void 0 ? void 0 : _storage.userNamev2) ? storage.userNamev2 : null;
    }
  }, {
    key: "getToken",
    value: function getToken(type) {
      if (type === _globalStrings.TOKEN_NAME_CIAM) {
        return storage ? storage.ciamtoken : null;
      }
      return storage ? storage.csctoken : null;
    }
  }, {
    key: "getRefreshToken",
    value: function getRefreshToken() {
      return storage ? storage.refreshToken : null;
    }
  }, {
    key: "setToken",
    value: function setToken(value, type) {
      if (type === _globalStrings.TOKEN_NAME_CIAM) {
        storage.ciamtoken = value;
      } else {
        storage.csctoken = value;
      }
    }
  }, {
    key: "setRefreshToken",
    value: function setRefreshToken(value) {
      storage.refreshToken = value;
    }
  }, {
    key: "generateCodeChallenge",
    value: function generateCodeChallenge(codeVerifier) {
      return this.base64URL((0, _sha.default)(codeVerifier));
    }
  }, {
    key: "base64URL",
    value: function base64URL(string) {
      return string.toString(_encBase.default).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    }
  }, {
    key: "generateCodeVerifier",
    value: function generateCodeVerifier() {
      var array = new Uint32Array(56 / 2);
      window.crypto.getRandomValues(array);
      // Converts it from dec to hex
      return Array.from(array, function (dec) {
        return "0".concat(dec.toString(16)).substr(-2);
      }).join('');
    }
  }, {
    key: "isUserAssignedToApp",
    value: function isUserAssignedToApp(appName) {
      var _this$parseJwt, _this$parseJwt$custom;
      var apId = (_this$parseJwt = this.parseJwt(this.getToken(_globalStrings.TOKEN_NAME_CIAM))) === null || _this$parseJwt === void 0 ? void 0 : (_this$parseJwt$custom = _this$parseJwt.custom_attributes) === null || _this$parseJwt$custom === void 0 ? void 0 : _this$parseJwt$custom.apps;
      return apId ? apId.indexOf(appName) !== -1 : false;
    }
  }, {
    key: "setIntermediateReadingMeterNumber",
    value: function setIntermediateReadingMeterNumber(meterNumber) {
      storage.setItem(storageKeys.intermediateReadingMeterNumber, meterNumber);
    }
  }, {
    key: "getIntermediateReadingMeterNumber",
    value: function getIntermediateReadingMeterNumber() {
      return storage.getItem(storageKeys.intermediateReadingMeterNumber);
    }
  }]);
  return SessionHandler;
}();
(0, _defineProperty2.default)(SessionHandler, "localRedirectLock", false);
var _default = exports.default = SessionHandler;